module.exports = __webpack_public_path__ + "img/live_pb.a1436bac.gif";